export const LOOP_STATUS = {
  ACTIVE: 1,
  FILED: 2,
  FINISHED: 3
};

export const LOOP_PRIORITY = {
  LOW: 1,
  MEDIUM: 2,
  HIGHT: 3
};

export const LOOP_PRIORITY_LABELS = {
  [LOOP_PRIORITY.LOW]: "loop.low",
  [LOOP_PRIORITY.MEDIUM]: "loop.medium",
  [LOOP_PRIORITY.HIGHT]: "loop.hight"
};

export const LOOP_PRIORITY_OPTIONS = [
  { value: LOOP_PRIORITY.LOW, key: "loop.low" },
  { value: LOOP_PRIORITY.MEDIUM, key: "loop.medium" },
  { value: LOOP_PRIORITY.HIGHT, key: "loop.hight" }
];

export const DEALT_STATUS = {
  OPEN: 1,
  ONGOING: 2,
  COMPLETED: 3
};

export const DEALT_STATUS_LABELS = {
  [DEALT_STATUS.OPEN]: "loop.open",
  [DEALT_STATUS.ONGOING]: "loop.ongoing",
  [DEALT_STATUS.COMPLETED]: "loop.completed"
};

export const LOOP_PRIORITY_CONTEXT = {
  [LOOP_PRIORITY.LOW]: "success",
  [LOOP_PRIORITY.MEDIUM]: "alert",
  [LOOP_PRIORITY.HIGHT]: "warn"
};

export const DEALT_ACTION = {
  BEGIN: 1,
  ASSIGN: 2,
  SEND_MESSAGE: 3,
  RECEIVE_MESSAGE: 4,
  CREATE_NOTE: 5,
  FINISH: 6,
  REOPEN: 7,
  CHANGE_PRIORITY: 8
};

export const DEALT_MAIL_STATUS = {
  CREATED: 0,
  PROCESSED: 1,
  DELIVERED: 2,
  DROPPED: 3,
  DEFERRED: 4,
  BOUNCE: 5,
  BLOCKED: 6
};

export const DEALT_MAIL_STATUS_ERRORS = [
  DEALT_MAIL_STATUS.DROPPED,
  DEALT_MAIL_STATUS.DEFERRED,
  DEALT_MAIL_STATUS.BOUNCE,
  DEALT_MAIL_STATUS.BLOCKED
];

export const DEALT_MAIL_STATUS_ERRORS_MESSAGES = {
  [DEALT_MAIL_STATUS.DROPPED]: "loop.dealts.errors.sendgrid_dropped",
  [DEALT_MAIL_STATUS.DEFERRED]: "loop.dealts.errors.sendgrid_deferred",
  [DEALT_MAIL_STATUS.BOUNCE]: "loop.dealts.errors.sendgrid_bounce",
  [DEALT_MAIL_STATUS.BLOCKED]: "loop.dealts.errors.sendgrid_blocked"
};
